import {MDB} from "../MDB";
import HacizInjectable from "./HacizInjectable";
import {
    BankadanHacizliParaninIstenilmesiParamsInterface,
    BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiParamsInterface,
    DosyadaHacizliMalinSatisiParamsInterface,
    DosyadakiAvansinIadesiParamsInterface,
    DosyaninIslemdenKaldirilmasiParamsInterface,
    DosyaninYetkiliIcraDairesineGonderilmesiParamsInterface,
    HacizliMalinKiymetTakdiriIcinTalimatYazilmasiParamsInterface,
    HacizliMalinSatisiIcinTalimatYazilmasiParamsInterface,
    HaricenTahsilatBildirimiParamsInterface,
    KiymetTakdirininYapilmasiParamsInterface,
    MaasUzerindekiHacizlerinKaldirilmasiParamsInterface,
    MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiParamsInterface,
    RehinAcigiBelgesiHazirlanmasiParamsInterface,
    YuzuncuMaddeyeYararBilgiIstenilmesiParamsInterface
} from "@/plugins/uyap-plugin/haciz/TopluDigerTalepParamsInterface";
import {DigerTalepEvrakTypeEnum} from "../uyap/enum/DigerTalepEvrakTypeEnum";
import TakipDosya from "@/plugins/uyap-plugin/uyap/classes/TakipDosya";

const mdb = new MDB();

export default class DigerTalepController extends HacizInjectable {
    constructor(borclu: any, dosya: TakipDosya) {
        super(borclu, dosya);
    }

    yuzuncuMaddeyeYararBilgiIstenilmesiEkle(params: YuzuncuMaddeyeYararBilgiIstenilmesiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.YuzuncuMaddeyeYararBilgiIstenilmesi);
        let talepObj = Object.assign({}, obj, {
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "aciklama": params.aciklama,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    acizBelgesiHazirlanmasiEkle(params: {
        aciklama: string,
    }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.AcizBelgesiHazirlanmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    aracUzerindekiHacizSerhininKaldirilmasiEkle(params: {
        plaka: string,
    }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.AracUzerindekiHacizSerhininKaldirilmasi);
        let talepObj = Object.assign({}, obj, {
            "plaka": params.plaka,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    aracUzerindekiYakalamaSerhininKaldirilmasiEkle(params: {
        plaka: string,
    }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.AracUzerindekiYakalamaSerhininKaldirilmasi);
        let talepObj = Object.assign({}, obj, {
            "plaka": params.plaka,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    bankadanHacizliParaninIstenilmesiEkle(params: BankadanHacizliParaninIstenilmesiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.BankadanHacizliParaninIstenilmesi);
        let talepObj = Object.assign({}, obj, {
            "bankaList": params.bankaList.join(","),
            "aciklama": params.aciklama,
            "hacizTarihi": params.hacizTarihi,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    borcluTarafindanYapilanOdemelerinHesabaAktarilmasiEkle(params: BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.BorclutarafindanYapilanOdemelerinHesabaAktarilmasi);
        let talepObj = Object.assign({}, obj, {
            "hesapKimeAit": params.hesapKimeAit.substr(0, 1),
            "hesapKimeAitText": params.hesapKimeAit,
            "ibanNo": params.ibanNo.replace(/ /g, ''),
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyaHesabininYapilmasiVeDosyayaKaydedilmesiEkle() {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyaHesabininYapilmasiVeDosyayaKaydedilmesi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": ""
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyadaHacizliMalinSatisiEkle(params: DosyadaHacizliMalinSatisiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyadaHacizliMalinSatisi);
        let talepObj = Object.assign({}, obj, {
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "aciklama": params.aciklama,
            "hacizTarihi": params.hacizTarihi
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyadakiAvansinIadesiEkle(params: DosyadakiAvansinIadesiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyadakiAvansinIadesi);
        let talepObj = Object.assign({}, obj, {
            "hesapKimeAit": params.hesapKimeAit.substr(0, 1),
            "hesapKimeAitText": params.hesapKimeAit,
            "ibanNo": params.ibanNo.replace(/ /g, ''),
            "masraf": obj.talepMasrafi,
            "fields": [
                {
                    "id": "hesapKimeAitText",
                    "title": "Hesap Kime Ait"
                },
                {
                    "id": "ibanNo",
                    "title": "IBAN No"
                }
            ]
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyadakiHacizlerinKaldirilmasiEkle(params: {
        aciklama: string
    }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyadakiHacizlerinKaldirilmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyaninIslemdenKaldirilmasiEkle(params: DosyaninIslemdenKaldirilmasiParamsInterface) {
        // Kapanma nedeni bos giderse UYAP talebi olusturmuyor, evrak sessizce kaybolmus oluyor.
        if (params.kapanmaId == null || !params.kapanmaAdi)
            throw new Error("Dosyanın İşlemden Kaldırılması talebi için kapanma nedeni seçilmelidir.");
        if (!params.aciklama)
            throw new Error("Dosyanın İşlemden Kaldırılması talebi için açıklama girilmelidir.");
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyaninIslemdenKaldirilmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "kapanmaAdi": params.kapanmaAdi,
            "kapanmaId": params.kapanmaId,
            "masraf": obj.talepMasrafi,
            "fields": [
                {
                    "id": "kapanmaAdi",
                    "title": "KapanmaNedeni"
                },
                {
                    "id": "aciklama",
                    "title": "Açıklama"
                }
            ]
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyaninYetkiliIcraDairesineGonderilmesiEkle(params: DosyaninYetkiliIcraDairesineGonderilmesiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyaninYetkiliIcraDairesineGonderilmesi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "birimAdi": params.birimAdi,
            "birimId": params.birimId,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    hacizliMalinKiymetTakdiriIcinTalimatYazilmasiEkle(params: HacizliMalinKiymetTakdiriIcinTalimatYazilmasiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.HacizliMalinKiymetTakdiriIcinTalimatYazilmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "birimAdi": params.birimAdi,
            "birimId": params.birimId,
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "hacizTarihi": params.hacizTarihi,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    hacizliMalinSatisiIcinTalimatYazilmasiEkle(params: HacizliMalinSatisiIcinTalimatYazilmasiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.HacizliMalinSatisiIcinTalimatYazilmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "birimAdi": params.birimAdi,
            "birimId": params.birimId,
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "hacizTarihi": params.hacizTarihi,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    hacizliTasinirMallarinMuhafazaAltinaAlinmasiEkle(params: { hacizTarihi: string }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.HacizliTasinirMallarinMuhafazaAltinaAlinmasi);
        let talepObj = Object.assign({}, obj, {
            "hacizTarihi": params.hacizTarihi,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    haricenTahsilatBildirimiEkle(params: HaricenTahsilatBildirimiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.HaricenTahsilatBildirimi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "tahsilatTarihi": params.tahsilatTarihi,
            "tahsilatTutari": params.tahsilatTutari,
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    iik121MaddeyeGoreYetkiVerilmesiEkle(params: { aciklama: string }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.IIk121MaddeyeGoreYetkiVerilmesi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    iik150cSerhiEklenmesiEkle(params: { aciklama: string }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.IIk150cSerhiEklenmesi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    kiymetTakdirininYapilmasiEkle(params: KiymetTakdirininYapilmasiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.KiymetTakdirininYapilmasi);
        let talepObj = Object.assign({}, obj, {
            "malTip": params.malTip,
            "malTipAciklama": params.malTipAciklama,
            "aciklama": params.aciklama,
            "hacizTarihi": params.hacizTarihi
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    maasUzerindekiHacizlerinKaldirilmesiEkle(params: MaasUzerindekiHacizlerinKaldirilmasiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.MaasUzerindekiHacizlerinKaldirilmesi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "calismaDurumu": params.calismaDurumu
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    muhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiEkle(params: MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "yeddiemin": params.yeddiemin,
            "muhafazaTarihi": params.muhafazaTarihi
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    rehinAcigiBelgesiHazirlanmasiEkle(params: RehinAcigiBelgesiHazirlanmasiParamsInterface) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.RehinAcigiBelgesiHazirlanmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama,
            "belgeTip": params.belgeTip,
            "belgeTipAciklama": params.belgeTipAciklama
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    rehininParayaCevrilmesiSerhiEkle(params: { aciklama: string }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.RehininParayaCevrilmesiSerhi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    tasinmazHaczininKaldirilmasiEkle(params: { aciklama: string }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.TasinmazHaczininKaldirilmasi);
        let talepObj = Object.assign({}, obj, {
            "aciklama": params.aciklama
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    dosyaYenilemeEkle() {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.DosyaYenileme);
        let talepObj = Object.assign({}, obj, {
            "aciklama": ""
        });
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    takibinKesinlesmesiEkle() {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.TakibinKesinlesmesi);
        let talepObj = Object.assign({}, obj, {});
        this.evrakTutar += obj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }

    ibanGuncellemesiEkle(params: { hesapKimeAit?: string, hesapKimeAitText?: string, ibanNo: string, ibanSecimi?: any }) {
        let obj = mdb.digerTalepler.find((i: any) => i.className == DigerTalepEvrakTypeEnum.IbanGuncelleme);

        let ibanSecimStr = "Alacaklı";
        let hesapKimeAitValue = "A";

        // Yeni format: hesapKimeAit ve hesapKimeAitText direkt geliyor
        if (params.hesapKimeAit && params.hesapKimeAitText) {
            hesapKimeAitValue = params.hesapKimeAit;
            ibanSecimStr = params.hesapKimeAitText;
        }
        // Eski format: ibanSecimi object veya string olarak geliyor (backward compatibility)
        else if (params.ibanSecimi) {
            // String format kontrolü (HAR'dan gelen format)
            if (typeof params.ibanSecimi === 'string') {
                if (params.ibanSecimi === 'Vekil') {
                    ibanSecimStr = "Vekil";
                    hesapKimeAitValue = "V";
                } else if (params.ibanSecimi === 'Alacaklı' || params.ibanSecimi === 'A') {
                    ibanSecimStr = "Alacaklı";
                    hesapKimeAitValue = "A";
                }
            }
            // Object format kontrolü (mevcut format - geriye uyumluluk için)
            else if (typeof params.ibanSecimi === 'object' && params.ibanSecimi !== null) {
                let ibanSecimiVekil = params.ibanSecimi["Vekil"];
                if (ibanSecimiVekil == true) {
                    ibanSecimStr = "Vekil";
                    hesapKimeAitValue = "V";
                }
            }
        }

        let talepObj = Object.assign({}, obj, {
            hesapKimeAit: hesapKimeAitValue,
            hesapKimeAitText: ibanSecimStr,
            ibanNo: params.ibanNo.replace(/ /g, ''),
        });
        this.evrakTutar += talepObj.talepMasrafi;
        this.pushTalepBilgileri(talepObj);
    }
}
